module.exports = __webpack_public_path__ + "img/SB icon.501cf6fd.png";